module.exports = __webpack_public_path__ + "static/overtime.dbba44cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/overtime.svg
// module id = 197
// module chunks = 35783957827783 189597454788034